<template>
  <transition name="fade-catalog">
    <!-- 当侧边栏为编辑时，总是打开 -->
    <div
      v-if="(isEditDrawerShow && isShowWindow === 2) || currentEditHeader !== 'catalog'"
      class="edit-wrapper fd-js-excludes"
      :class="[
        MobileClass,
        catalogClass,
        BigScreenClass,
        catelogOrSearchKey,
        {
          AsideAnimate: (!isMobile && !$route.meta.requiresAuth) || !isShowCommerHeader,
          AsideEditor: !isMobile && isShowCommerHeader && $route.meta.requiresAuth && this.currentEditHeader !== 'catalog'
        }
      ]"
      @click="handleShowML"
      id="edit-wrapper"
    >
      <div class="catalog-box fd-js-excludes">
        <component :is="currentEditHeaderTitle || currentEditHeader" />
      </div>
    </div>
  </transition>
</template>
<script>
import EditContent from './edit/EditContent.vue'
import Catalog from './edit/Catalog.vue'
import { judgeBigScreen } from '@/utils'
import { mapState } from 'vuex'
import compareVipRight from '@components/common/compareVipRight.js'
export default {
  data() {
    return {
      direction: 'ttb',
      isBigScreen: false //是否是iphone屏幕
    }
  },
  mixins: [compareVipRight],
  props: ['currentEditHeaderTitle'],
  computed: {
    ...mapState('book', ['isShowWindow']),
    isEditDrawerShow() {
      return this.$store.state.edit.isEditDrawerShow
    },
    // 控制左侧显示树还是编辑区域
    currentEditHeader() {
      return this.$store.state.edit.currentEditHeader
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    MobileClass() {
      return this.isMobile ? 'mobile' : ''
    },
    catalogClass() {
      return this.currentEditHeader == 'catalog' ? 'edit-wrapper' : 'edit-wrapper-box'
    },
    BigScreenClass() {
      return this.isBigScreen ? 'big-mobile' : ''
    },
    isShowCommerHeader() {
      return this.$store.state.book.isShowCommerHeader
    },
    catelogOrSearchKey() {
      return this.isEditDrawerShow && localStorage.getItem('isshowSearch') ? 'catelog-or-searchKey' : ''
    }
  },
  mounted() {
    if (judgeBigScreen()) {
      this.isBigScreen = true
      this.$store.commit('book/UPDATE_IS_BIG_SCREEN', true)
    }
    this.getVipInfo()
  },
  components: {
    EditContent,
    Catalog
  },
  methods: {
    handleShowML() {
      if (this.isMobile) {
        this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false)
      }
    }
  }
}
</script>
<style lang="scss">
.edit-wrapper {
  width: 280px;
  position: fixed;
  left: 0;
  z-index: 120;
  background-color: #fff;
  // 侧边栏上下留白边
  // height: 90%;
  // height: calc(90% - 36px);
  // height: 100vh - (100% - 40) * 5% + 40 5% -
  // 这回不留白边和
  height: calc(100% - 160px);
  top: 120px;
  // top: 50%;
  // transform: translateY(-50%);
  overflow: hidden;
  &.mobile {
    width: 100% !important;
    height: 100%;
    position: fixed;
    background: none;
    z-index: 2001;
    top: 0;
    transform: none;
    // &.big-mobile {
    //   height: calc(100% - 56px);
    // }
    // ios全屏样式
    .catalog-box {
      // width: 90vw;
      width: 100vw;
      height: 100%;
      background: #ddd;
    }
  }
}
.catalog-box {
  width: 100%;
  height: 100%;
}
.edit-wrapper-box {
  // 书刊编辑
  width: 260px;
  height: 100%;
  // height: calc(100% - 80px);
  background-color: #fff;
  // overflow: hidden;
  top: 0;
  // bottom: 0;
}
// 目前分两块，一个是有导航栏目录充满另一个是没有导航栏目录，两个有全屏情况要考虑
.AsideAnimate {
  // height: 100%;
  height: calc(100% - 80px);
  // top: 0;
  top: 40px;
  transform: none;
  // calc(5% - 8px + 120)
}
.AsideEditor {
  height: calc(100% - 80px);
  top: 80px;
  overflow: hidden;
}
.catelog-or-searchKey {
  z-index: 2001;
}
.fade-catalog-enter-active,
.fade-catalog-leave-active {
  transition: all 0.5s;
}
.fade-catalog-enter,
.fade-catalog-leave-to {
  transform: translateX(-280px);
  opacity: 0;
}
</style>
